import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"

import { PageHeader } from "@/components/common/page-header"
import { ActivityTimeline } from "@/features/activity/components/activity-timeline"
import { FirmOverviewBlock } from "@/features/firms/components/firm-overview-block"
import { FirmStanding } from "@/features/firms/components/firm-standing"
import { FirmRegisterWarnings } from "@/features/register/components/register-warnings"
import { RequestActions } from "@/features/requests/components/request-actions"
import { firmQueries } from "@/queries/firms"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/firms/$firmId/"
)({
  component: FirmOverviewPage,
})

function FirmOverviewPage() {
  const { firmId } = Route.useParams()
  const { data: firm } = useSuspenseQuery(firmQueries.detail(firmId))

  return (
    <>
      <PageHeader
        title="Overview"
        actions={
          <RequestActions
            subject={{ type: "firm", id: firm.id }}
            name={firm.legalName}
            can={firm.can}
          />
        }
      />
      <div className="mx-auto flex w-full max-w-5xl flex-col gap-10">
        <FirmStanding firm={firm} />
        <FirmRegisterWarnings firm={firm} />
        {firm.overview.map((block) => (
          <FirmOverviewBlock key={block} firm={firm} block={block} />
        ))}
        <ActivityTimeline subject={{ type: "firm", id: firm.id }} />
      </div>
    </>
  )
}
